/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Mini_S2Inputs */

const en_tut_mini_s2 = /** @type {(inputs: Tut_Mini_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If your browser supports it, press **Mini selalu di depan** so the window floats above the others.`)
};

const id_tut_mini_s2 = /** @type {(inputs: Tut_Mini_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau browser Anda mendukung, tekan **Mini selalu di depan** agar jendela itu mengambang di atas jendela lain.`)
};

/**
* | output |
* | --- |
* | "If your browser supports it, press **Mini selalu di depan** so the window floats above the others." |
*
* @param {Tut_Mini_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_mini_s2 = /** @type {((inputs?: Tut_Mini_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Mini_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_mini_s2(inputs)
	return en_tut_mini_s2(inputs)
});